// extracted by mini-css-extract-plugin
export default {"row":"ConfirmPassword_row__Fdond","col":"ConfirmPassword_col__O30kY","reset-pw":"ConfirmPassword_reset-pw__2Zxzo"};